import { useTheme } from "@/context/ThemeContext";
import { useLanguage } from "@/context/LanguageContext";
import { supportLabels } from "@/i18n";

export const DeliveryChecklist = () => {
  const { theme } = useTheme();
  const { language } = useLanguage();
  const c = supportLabels(language).docGuideContent?.deliveryChecklist ?? {};
  const isDark = theme === "dark";

  const listItem = (text: string) => (
    <div className="flex items-start gap-2">
      <span className="text-lg">☐</span>
      <span className="text-sm">{text}</span>
    </div>
  );

  return (
    <div className="space-y-6">
      <div>
        <h4
          className={`font-semibold mb-3 text-base ${
            isDark ? "text-white" : "text-black"
          }`}
        >
          {c.section1Title}
        </h4>
        <div
          className={`space-y-2 ml-4 ${
            isDark ? "text-gray-300" : "text-gray-700"
          }`}
        >
          {listItem(c.section1Item1)}
          {listItem(c.section1Item2)}
          {listItem(c.section1Item3)}
          {listItem(c.section1Item4)}
        </div>
      </div>

      <div>
        <h4
          className={`font-semibold mb-3 text-base ${
            isDark ? "text-white" : "text-black"
          }`}
        >
          {c.section2Title}
        </h4>
        <div
          className={`space-y-2 ml-4 ${
            isDark ? "text-gray-300" : "text-gray-700"
          }`}
        >
          {listItem(c.section2Item1)}
          {listItem(c.section2Item2)}
          {listItem(c.section2Item3)}
        </div>
        <p className={`text-xs mt-2 ml-4 ${isDark ? "text-gray-400" : "text-gray-500"}`}>
          {c.section2Note}
        </p>
      </div>
    </div>
  );
};
